// src/api/axiosInstance.ts
import axios from "axios";
import API_URL from "../../apiConfig";
import { StoreService } from "../store/applicationStateService";
import { useNavigate } from "react-router";

export const apiRoutePrefix: string = "/api";

const httpClient = axios.create({
  baseURL: API_URL, // Your backend API prefix
  timeout: 1000000,
  headers: {
    "Content-Type": "application/json",
  },
});

httpClient.interceptors.request.use(
  (config) => {
    const token = StoreService.getStorage("jwtToken");
    const userId = StoreService.getStorage("userId");

    config.headers = config.headers || {};
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
      config.headers["UserId"] = userId;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";

    if (status === 401) {
      localStorage.clear();
      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
    }

    // Optional: Log message for debugging
    // if (status === 403 && url.includes("processQueuedTasks")) {
    //   console.warn(
    //     "⛔ 403 from processQueuedTasks — blocking but not redirecting"
    //   );
    // }

    return Promise.reject(error); // VERY IMPORTANT — reject the error properly
  }
);

export default httpClient;
